import { render, staticRenderFns } from "./question-default-value-actions.vue?vue&type=template&id=b827e936&scoped=true"
import script from "./question-default-value-actions.vue?vue&type=script&lang=js"
export * from "./question-default-value-actions.vue?vue&type=script&lang=js"
import style0 from "./question-default-value-actions.vue?vue&type=style&index=0&id=b827e936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b827e936",
  null
  
)

/* custom blocks */
import block0 from "@/common/i18n/i18n-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fsean%2FDocuments%2FEZMeals%2Fezmeals-store-management-ui%2Fsrc%2Fpages%2Fmenu-draft%2Fmodals%2Fquestion-default-value-actions.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports